<template>
  <div class="file-center">
    <!-- 左侧上传区域 -->
    <div class="upload-section">
      <el-card class="upload-card" shadow="always">
        <div class="upload-header">
          <h3 class="upload-title">文件上传</h3>
          <p class="upload-subtitle">支持多种文件格式</p>
        </div>
        
        <el-upload
          class="upload-demo"
          ref="upload"
          action="http://47.108.21.146:7777/files/saveFileList"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-change="handleChange"
          :file-list="fileList"
          :auto-upload="false"
          drag
        >
          <div class="upload-area">
            <i class="el-icon-upload"></i>
            <div class="upload-text">
              <p>将文件拖到此处，或<em>点击上传</em></p>
              <p class="upload-tip">支持单个或批量上传，文件大小不超过10MB</p>
            </div>
          </div>
        </el-upload>
        
        <div class="upload-actions">
          <el-button 
            type="primary" 
            icon="el-icon-upload2"
            @click="submitUpload"
            :disabled="fileList.length === 0"
            class="upload-btn"
          >
            上传到服务器
          </el-button>
          <el-button 
            type="info" 
            icon="el-icon-refresh"
            @click="clearFiles"
            :disabled="fileList.length === 0"
            class="clear-btn"
          >
            清空列表
          </el-button>
        </div>
      </el-card>
    </div>

    <!-- 右侧文件列表区域 -->
    <div class="file-list-section">
      <el-card class="file-list-card" shadow="always">
        <div class="card-header">
          <div class="header-info">
            <h2 class="section-title">文件列表</h2>
            <el-tag type="info" size="small" class="count-tag">
              共 {{ allFiles.length }} 个文件
            </el-tag>
          </div>
          <div class="header-actions">
            <el-button 
              type="primary" 
              icon="el-icon-refresh"
              @click="getAllFiles"
              class="refresh-btn"
            >
              刷新
            </el-button>
          </div>
        </div>

        <el-table
          :max-height="tableHeight"
          :data="allFiles.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) || data.id.toLowerCase().includes(tableSearch.toLowerCase()))"
          class="file-table"
          stripe
        >
          <el-table-column
            label="序号"
            type="index"
            width="80"
            align="center"
          />
          
          <el-table-column
            label="文件信息"
            min-width="40%"
            class-name="file-info-column"
          >
            <template slot-scope="{ row }">
              <div class="file-info">
                <div class="file-icon">
                  <i :class="getFileIcon(row.name)"></i>
                </div>
                <div class="file-details">
                  <div class="file-name">{{ row.name }}</div>
                  <div class="file-id">ID: {{ row.id }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column
            label="文件分类"
            prop="type"
            min-width="20%"
            class-name="file-type-column"
          >
            <template slot-scope="{ row }">
              <el-tag 
                :type="getFileTypeTag(row.type)" 
                size="small"
                class="type-tag"
              >
                {{ row.type }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column 
            label="操作" 
            min-width="40%"
            class-name="action-column"
          >
            <template slot="header">
              <el-input 
                v-model="tableSearch" 
                size="small" 
                placeholder="搜索文件名或ID"
                prefix-icon="el-icon-search"
                class="search-input"
              />
            </template>
            <template slot-scope="scope">
              <div class="action-buttons">
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-edit"
                  @click="beforeUpdateType(scope.row)"
                  class="action-btn edit-btn"
                >
                  修改分类
                </el-button>
                <el-button
                  size="small"
                  type="success"
                  icon="el-icon-download"
                  @click="handleDownload(scope.$index, scope.row)"
                  class="action-btn download-btn"
                >
                  下载
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  icon="el-icon-delete"
                  @click="beforeDelete(scope.$index, scope.row)"
                  class="action-btn delete-btn"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <!-- 修改文件分类对话框 -->
    <el-dialog 
      title="修改文件分类" 
      :visible.sync="selectTypeVisible"
      width="500px"
      class="custom-dialog"
    >
      <el-form :model="updateForm" label-width="120px" class="dialog-form">
        <el-form-item label="文件名称">
          <el-input v-model="seletedFile.name" disabled />
        </el-form-item>
        <el-form-item label="选择分类">
          <el-select v-model="updateTypeId" placeholder="请选择文件分类" style="width: 100%">
            <el-option
              v-for="item in types"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="selectTypeVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateTypeById">确 定</el-button>
      </div>
    </el-dialog>
    </div>
</template>

<script>
import { fileApi } from '@/api'

export default {
  name: 'FileCenter',
  data () {
    return {
      fileList: [],
      allFiles: [],
      tableSearch: '',
      tableHeight: window.innerHeight * 0.8,
      types: [],
      selectTypeVisible: false,
      seletedFile: '',
      updateTypeId: ''
    }
  },
  mounted () {
    this.getAllFiles()
    this.getFileType()
  },
  methods: {
    // 获取文件图标
    getFileIcon (fileName) {
      const ext = fileName.split('.').pop().toLowerCase()
      const iconMap = {
        'pdf': 'el-icon-document',
        'doc': 'el-icon-document',
        'docx': 'el-icon-document',
        'txt': 'el-icon-document',
        'jpg': 'el-icon-picture',
        'jpeg': 'el-icon-picture',
        'png': 'el-icon-picture',
        'gif': 'el-icon-picture',
        'mp4': 'el-icon-video-camera',
        'avi': 'el-icon-video-camera',
        'mov': 'el-icon-video-camera',
        'mp3': 'el-icon-headset',
        'wav': 'el-icon-headset',
        'zip': 'el-icon-folder',
        'rar': 'el-icon-folder',
        '7z': 'el-icon-folder',
        'xls': 'el-icon-document',
        'xlsx': 'el-icon-document',
        'ppt': 'el-icon-document',
        'pptx': 'el-icon-document'
      }
      return iconMap[ext] || 'el-icon-document'
    },

    // 获取文件类型标签样式
    getFileTypeTag (type) {
      const typeMap = {
        '图片': 'success',
        '文档': 'primary',
        '视频': 'warning',
        '音频': 'info',
        '压缩包': 'danger'
      }
      return typeMap[type] || 'info'
    },

    // 清空文件列表
    clearFiles () {
      this.fileList = []
      this.$refs.upload.clearFiles()
    },

    async updateTypeById () {
      try {
        await fileApi.updateFileType(this.seletedFile.id, this.updateTypeId)
        this.getAllFiles()
        this.selectTypeVisible = false
        this.$message.success('更新文件类型成功')
      } catch (error) {
        console.error('更新文件类型失败:', error)
      }
    },
    async getFileType () {
      try {
        const response = await fileApi.getFileTypes()
        this.types = response
      } catch (error) {
        console.error('获取文件类型失败:', error)
      }
    },
    beforeUpdateType (file) {
      this.selectTypeVisible = true
      this.seletedFile = file
    },
    async getAllFiles () {
      try {
        const response = await fileApi.getAllFiles()
        this.allFiles = response
      } catch (error) {
        console.error('获取文件列表失败:', error)
      }
    },
    async submitUpload () {
      if (this.fileList.length <= 0) {
        this.$message.warning('请选择需要上传的文件！')
        return
      }
      for (let i in this.fileList) {
        if (this.fileList[i].size / 1024 / 1024 > 10) {
          this.$message.error(this.fileList[i].name + ' 文件大小超过10M，上传文件大小不能超过 10MB!')
          return
        }
      }
      try {
        await fileApi.uploadFiles(this.fileList)
        this.$message.success('文件上传成功！')
        this.fileList = []
        this.getAllFiles()
      } catch (error) {
        console.error('文件上传失败:', error)
      }
    },
    handleRemove (file) {
      for (let i in this.fileList) {
        if (this.fileList[i].uid === file.uid) {
          this.fileList.splice(i, 1)
          i--
        }
      }
    },
    beforeRemove (file) {
      console.log(file)
      return this.$confirm('确定移除' + file.name + '?')
    },
    handleBeforeUpload (file) {
      console.log('123')
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
    },
    beforeSubmitUpload () {
      this.submitUpload()
    //   if (file.size / 1024 / 1024 > 10) {
    //     this.$message.error('上传图片大小不能超过 10MB!')
    //   }
    },
    handleChange (file, fileList) {
      this.fileList = fileList
    },
    async deleteFile (file) {
      try {
        await fileApi.deleteFile(file.id)
        this.$message.success('删除成功！')
        this.getAllFiles()
      } catch (error) {
        console.error('删除文件失败:', error)
      }
    },
    beforeDelete (index, file) {
      this.$confirm('是否删除文件  ' + file.name, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFile(file)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleDownload (index, file) {
      // 创建下载链接
      const link = document.createElement('a')
      link.href = file.url
      link.download = file.name
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.file-center {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
  gap: 20px;
  padding: 20px;
}

/* 左侧上传区域 */
.upload-section {
  width: 400px;
  flex-shrink: 0;
}

.upload-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.upload-header {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.upload-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
}

.upload-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

/* 上传区域 */
.upload-demo {
  margin-bottom: 20px;
}

.upload-area {
  padding: 40px 20px;
  text-align: center;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.3s ease;
}

.upload-area:hover {
  border-color: #409EFF;
  background: #f0f9ff;
}

.upload-area i {
  font-size: 48px;
  color: #c0c4cc;
  margin-bottom: 16px;
  display: block;
}

.upload-text p {
  margin: 8px 0;
  color: #606266;
  font-size: 14px;
}

.upload-text em {
  color: #409EFF;
  font-style: normal;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
}

/* 上传按钮 */
.upload-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.upload-btn, .clear-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.upload-btn:hover, .clear-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 右侧文件列表区域 */
.file-list-section {
  flex: 1;
  min-width: 0;
}

.file-list-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.count-tag {
  background-color: #F4F4F5;
  color: #909399;
  border: none;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.refresh-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.refresh-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 表格样式 */
.file-table {
  border-radius: 8px;
  overflow: hidden;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.file-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f9ff;
  color: #409EFF;
  font-size: 20px;
  flex-shrink: 0;
}

.file-details {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
  word-break: break-word;
}

.file-id {
  font-size: 12px;
  color: #909399;
}

.type-tag {
  border-radius: 4px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.action-btn {
  border-radius: 6px;
  font-size: 12px;
  padding: 6px 12px;
  transition: all 0.3s ease;
}

.edit-btn {
  background-color: #ECF5FF;
  color: #409EFF;
  border-color: #B3D8FF;
}

.edit-btn:hover {
  background-color: #409EFF;
  color: white;
}

.download-btn {
  background-color: #F0F9FF;
  color: #67C23A;
  border-color: #B3E19D;
}

.download-btn:hover {
  background-color: #67C23A;
  color: white;
}

.delete-btn {
  background-color: #FEF0F0;
  color: #F56C6C;
  border-color: #FBC4C4;
}

.delete-btn:hover {
  background-color: #F56C6C;
  color: white;
}

/* 搜索输入框 */
.search-input {
  width: 200px;
}

/* 对话框样式 */
.custom-dialog .el-dialog {
  border-radius: 12px;
}

.custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  padding: 20px;
}

.custom-dialog .el-dialog__title {
  color: white;
  font-weight: 600;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.custom-dialog .el-dialog__body {
  padding: 30px;
}

.dialog-form .el-form-item {
  margin-bottom: 20px;
}

.dialog-form .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.dialog-footer .el-button {
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .file-center {
    flex-direction: column;
    gap: 15px;
  }
  
  .upload-section {
    width: 100%;
  }
  
  .upload-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .upload-btn, .clear-btn {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .file-center {
    padding: 10px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
  
  .action-btn {
    width: 100%;
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .search-input {
    width: 100%;
  }
  
  .file-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .file-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
  
  .custom-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .upload-area {
    padding: 20px 10px;
  }
  
  .upload-area i {
    font-size: 36px;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .count-tag {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/file/FileCenter.vue